import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import { environment } from 'src/environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let requestUrl = request.url;
    if (!/^https?:\/\//.test(requestUrl)) {
      requestUrl = `${environment.apiUrl}/${requestUrl}`;
    }


    let newRequest = request
      .clone({
        url: requestUrl,
        setHeaders: {
          'Accept-Language': localStorage.getItem('lang') ?? 'en',

          'X-Platform': 'web'
        }
      })
      .clone({
        setHeaders:
          request.url === 'passphrase'
            ? {
              'Req-UUID': uuidv4(),
              'Res-UUID': uuidv4()
            }
            : {}
      });

    if (request.params.get('staticFile')) {
      newRequest = request;
    }


    return next.handle(newRequest);
  }
}
